<script lang="ts">
  import type { firstStepConfig } from '../config';
  import { getFirstStepData } from '../model';
  import { createEventDispatcher } from 'svelte';
  import { TextField } from '@shared/ui/fields/text-field';
  import { Select } from '@shared/ui/fields/select';
  import Noticed from './noticed.svelte';
  import { PhoneField } from '@shared/ui/fields/phone-field';
  import { ArrowButton } from '@shared/ui/buttons/arrow-button';

  const dispatcher = createEventDispatcher();

  const major = [
    { text: 'Gallery', value: 'gallery' },
    { text: 'Art Institution', value: 'art_institution' },
    { text: 'Artist', value: 'artist' },
    { text: 'Tech-expert', value: 'tech-expert' },
    { text: 'Collector', value: 'collector' },
    { text: 'Photographer', value: 'photographer' },
    { text: 'Partner', value: 'partner' },
    { text: 'Adviser', value: 'adviser' },
    { text: 'Other', value: 'other' },
  ];

  export let formData: firstStepConfig.FirstStepContactForm;

  const handleSubmit = () => {
    dispatcher('successSubmit', $form);
  };

  const { form, errors, enhance } = getFirstStepData(formData, handleSubmit);

  const handleSelectChange = (selectedOption: CustomEvent) => {
    $form.major = selectedOption.detail.value;
  };
</script>

<form method="POST" class="flex flex-col" action="?/first" use:enhance>
  <TextField
    bind:value="{$form.full_name}"
    state="{$errors.full_name && 'error'}"
    helperText="{$errors.full_name}"
    label="Full name"
    placeholder="John Galt"
    name="full_name"
  />

  <TextField
    bind:value="{$form.email}"
    state="{$errors.email && 'error'}"
    helperText="{$errors?.email && $errors.email[0]}"
    label="Email"
    placeholder="johngalt@gmail.com"
    name="email"
    inputmode="email"
  />

  <PhoneField
    bind:value="{$form.phone}"
    state="{$errors.phone && 'error'}"
    helperText="{$errors.phone}"
    label="Phone"
    placeholder="Phone"
    mask="phone"
  />

  <Select
    on:change="{handleSelectChange}"
    state="{$errors.major && 'error'}"
    helperText="{$errors.major}"
    name="major"
    label="Who are you"
    options="{major}"
    isMargin
  />

  <Noticed />

  <ArrowButton hugged type="submit" variant="third" classes="gap-6" slotClasses="leading-none">Next</ArrowButton>
</form>
